import { Outlet } from 'react-router';
import { Header } from '@/components/Header';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorHandler } from '../Common';
import { useResetCampusOnUwIdChange } from '@/hooks';

export const Layout = () => {
  // Reset the selected campus when the unit workload id changes.
  // Call the useResetCampusOnUwIdChange hook here as there's no separate layout for unit-workloads route
  // and this hook runs on every view switch even when uwId hasn't changed.
  // That's because each 'tab' view is a separate component and useResetCampusOnUwIdChange() is being called in all
  // of them — and their useEffect() re-runs on mount - this will cause the selectedCampusId get reset everytime user
  // switch between TD or TRD 'tab' view.
  useResetCampusOnUwIdChange();

  return (
    <ErrorBoundary FallbackComponent={ErrorHandler}>
      <div className="grid h-screen grid-rows-[60px_auto]">
        <div className="sticky top-0 z-20 flex">
          <Header />
        </div>
        <Outlet />
      </div>
    </ErrorBoundary>
  );
};
